import { render, staticRenderFns } from "./allocate-buttons.vue?vue&type=template&id=742cef54&scoped=true"
import script from "./allocate-buttons.vue?vue&type=script&lang=js"
export * from "./allocate-buttons.vue?vue&type=script&lang=js"
import style0 from "./allocate-buttons.vue?vue&type=style&index=0&id=742cef54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742cef54",
  null
  
)

export default component.exports